import React from 'react'
import {change as changeFieldValue, Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Select from 'react-select';
import $ from 'jquery';
import {renderFieldCheck} from '../../../util/inputs';
import buscarRotas from '../../../actions/rota/buscarRotas';
import selecionarRota from '../../../actions/rota/selecionarRota';
import cadastrarDescontoUsuarioRota from '../../../actions/usuario/cadastrarUsuarioDescontoRota';
import buscarDescontosUsuarioRota from '../../../actions/desconto/buscarDescontosUsuarioRota';
import {showSuccessMsg} from '../../../util/messagesUtil';
import axios from 'axios';
import {SLOW_REQUEST_CONFIG} from '../../../util/loadingUtil';
import {URL} from '../../../util/ambienteActions';
import NumberFormat from 'react-number-format';
import excluirDescontoUsuarioRota from '../../../actions/desconto/excluirDescontoUsuarioRota';

export const validate = (values) => {
    const errors = {};
    if (!values.nome) {
        errors.nome = 'Campo obrigatório'
    }
    if (!values.email) {
        errors.email = 'Campo obrigatório'
    }

    return errors
};


export class modalCadastrarUsuarioDescontoRota extends React.Component {
    constructor(props) {
        super(props);
        this.fechar = this.fechar.bind(this);
        this.limparCampos = this.limparCampos.bind(this);
        this.limparFormulario = this.limparFormulario.bind(this);
        this.submit = this.submit.bind(this);
        this.adicionarRemoverDesconto = this.adicionarRemoverDesconto.bind(this);
        this.state = {
            descontosSelecionados: [],
            rotasSelecionadas: [],
            descontoMaximo: '',
        }

    }

    componentDidMount() {
        this.props.buscarRotas(this.props.empresaSelecionada.id);
    }

    adicionarRemoverDesconto(desconto) {
        let descontos = this.state.descontosSelecionados;
        if (descontos.filter(it => it === desconto).length > 0) {
            this.setState({descontosSelecionados: descontos.filter(it => it !== desconto)})
            document.getElementById('selecionarTodosDescontos').checked = false;
        } else {
            descontos.push(desconto);
            document.getElementById('selecionarTodosDescontos').checked = false;
            this.setState({descontosSelecionados: descontos})
        }
    }

    montarParametroUsuario() {
        return {
            idsRotas: this.state.rotasSelecionadas.map(it => it.value),
            idUsuario: this.props.usuarioSelecionado.id,
            descontoMaximo: this.state.descontoMaximo,
        };
    }

    submit() {
        this.props.cadastrarDescontoUsuarioRota(this.montarParametroUsuario(), this.props.empresaSelecionada.id)
            .then(() => {
                showSuccessMsg('Desconto usuário cadastrado com sucesso');
                this.props.buscarDescontosUsuarioRota(this.props.empresaSelecionada.id, this.props.usuarioSelecionado.id);
                this.limparFormulario();
            })
    }

    fecharModal() {
        $('#modalCadastrarUsuarioDescontoRota')
            .modal('hide');
        $('#modalCadastrarUsuarioDescontoRota')
            .hide();
        $('.modalCadastrarUsuarioDescontoRota')
            .hide();
    }

    limparFormulario() {
        this.props.reset('frmCadastroUsuarioDescontoRota');
        this.setState({
            perfisSelecionados: [],
            usuario: '',
            descontosSelecionados: [],
            rotasSelecionadas: [],
            menuOpen: false,
            descontoMaximo: '',
        })
    }

    limparCampos() {
        this.props.changeFieldValue('frmCadastroUsuarioDescontoRota',
            'descontoMaximo', '');
        this.props.limparPerfis();
    }

    fechar() {
        this.setState({paginaAtual: 1});
        this.limparFormulario();
    }

    excluir(descontosUsuarioRota) {
        this.props.excluirDescontoUsuarioRota(descontosUsuarioRota.id, this.props.empresaSelecionada.id)
            .then(() => {
                this.props.buscarDescontosUsuarioRota(this.props.empresaSelecionada.id, this.props.usuarioSelecionado.id);
            })
    }

    exibirDescontoUsuario() {
        if (!this.props.descontosUsuarioRota) {
            return 'Não existem descontos cadastrados para o usuário.'
        }
        return this.props.descontosUsuarioRota.map((descontoUsuarioRota) => <div
            key={`desconto-${descontoUsuarioRota.id}`} className="geral">
            <div className="resumo">
                <div className="row">
                    <div className="col-lg-2 col-xl-2">
                        <div className='form-group form-check'>
                            <input className="form-check-input" type="checkbox"
                                   key={`ck-desconto-${descontoUsuarioRota.id}`}
                                   id={`ck-desconto-${descontoUsuarioRota.id}`}
                                   onClick={() => this.adicionarRemoverDesconto(descontoUsuarioRota.id)}
                                   checked={this.state.descontosSelecionados.find(it => it === descontoUsuarioRota.id) !== undefined}/>
                        </div>
                    </div>
                    <div className="col-lg-6 col-xl-6">
                                <span
                                    className="titulo-mobile">Nome:&nbsp;</span>{descontoUsuarioRota.descRota}
                    </div>
                    <div className="col-lg-2 col-xl-2">
                                <span
                                    className="titulo-mobile">Desconto máximo:&nbsp;</span>{descontoUsuarioRota.descontoMaximo} %
                    </div>
                    <div className="col-lg-2 col-xl-2">
                        <div className="acoes">
                            <div className="botoes">
                                <button type="button" className="btn btn-excluir"
                                        key={descontoUsuarioRota.id}
                                        onClick={() => this.excluir(descontoUsuarioRota)}>
                                    <i className="material-icons nav-icon">&#xe872;</i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>)
    }

    excluirDescontos() {
        const url = `${URL}/desconto-usuario-rota/empresa/${this.props.empresaSelecionada.id}/excluir`;
        axios.post(url, this.state.descontosSelecionados, SLOW_REQUEST_CONFIG).then(() => {
            showSuccessMsg('Descontos excluídos com sucesso!');
            this.props.buscarDescontosUsuarioRota(this.props.empresaSelecionada.id, this.props.usuarioSelecionado.id);
            this.limparFormulario();
        })
    }

    selecionarTodosDescontos(event) {
        if (this.props.descontosUsuarioRota && (event.target.value === 'false' || event.target.value === '')) {
            this.setState({descontosSelecionados: this.props.descontosUsuarioRota.map(it => it.id)})
        } else {
            this.setState({descontosSelecionados: []})
        }

    }

    render() {
        const {
            handleSubmit
        } = this.props;
        return (
            <div className="modal fade show" id='modalCadastrarUsuarioDescontoRota' role='dialog'
                 aria-labelledby='modalCadastrarUsuarioDescontoRota' aria-hidden='true' data-backdrop='static'>
                <div className={'modal-dialog modal-dialog-centered modal-lg'}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5>Novo Desconto Usuário</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                    onClick={() => this.fechar()}>
                                <i className="material-icons">
                                    &#xe5cd;
                                </i>
                            </button>

                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmit(this.submit)}>
                                <div className='col-10 col-sm-10 col-md-10'>
                                    <label>Rota</label>
                                    {this.props.rotas ?
                                        <div>
                                            <Select
                                                placeholder='Selecione...'
                                                closeMenuOnSelect={false}
                                                isMulti
                                                value={this.state.rotasSelecionadas}
                                                onChange={event => this.setState({rotasSelecionadas: [...event]})}
                                                options={this.props.rotas.map(elemento => (
                                                    {
                                                        label: elemento.descricao,
                                                        value: elemento.id
                                                    }))}
                                            />
                                        </div> : ''}
                                </div>
                                <div className='col-10 col-sm-10 col-md-8 '>
                                    <div>
                                        <label className='mt-2'>Desconto máximo para rota (%)</label>
                                        <div>
                                            <NumberFormat format="##.##"
                                                          value={this.state.descontoMaximo}
                                                          id='descontoMaximo'
                                                          className='form-control col-md-2'
                                                          onChange={event => this.setState({descontoMaximo: event.target.value})}/>
                                        </div>
                                    </div>

                                    <button id="btn-salvar" disabled={this.state.descontoMaximo.trim().length !== 5}
                                            type="submit" className="btn btn-laranja mt-2">Incluir
                                    </button>
                                    {this.state.descontosSelecionados.length ?
                                        <button type="button" onClick={() => this.excluirDescontos()}
                                                className="btn btn-laranja mt-2 ml-2">Excluir
                                        </button> : ''}
                                </div>

                            </form>
                            <div id="header-tabela" className="lista-table">
                                <div className="row cabecalho-desktop">
                                    <div className="col-lg-2 col-xl-2"><Field type="checkbox"
                                                                              name='selecionarTodosDescontos'
                                                                              component={renderFieldCheck}
                                                                              css="form-check-input" readOnly={false}
                                                                              onChange={(e) => this.selecionarTodosDescontos(e)}/>
                                    </div>
                                    <div className="col-lg-6 col-xl-6">Rota</div>
                                    <div className="col-lg-2 col-xl-2">Desconto máximo</div>
                                    <div className="col-lg-2 col-xl-2">Ação</div>
                                </div>
                            </div>
                            <div className="lista-table">
                                {this.exibirDescontoUsuario()}
                            </div>
                        </div>
                        <div className="modal-footer">
                            {this.state.descontosSelecionados.length ?
                                <button type="button" onClick={() => this.excluirDescontos()}
                                        className="btn btn-laranja btn-floating">Excluir
                                </button> : ''}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        empresaSelecionada: state.empresaSelecionada,
        usuarioSelecionado: state.usuarioSelecionado,
        rotaSelecionada: state.rotaSelecionada,
        rotas: state.rotas.rotas,
        descontosUsuarioRota: state.descontosUsuarioRota,
        descontoUsuarioRotaSelecionado: state.descontoUsuarioRotaSelecionado
    }
}


export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
        cadastrarDescontoUsuarioRota,
        buscarRotas,
        buscarDescontosUsuarioRota,
        selecionarRota,
        excluirDescontoUsuarioRota
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'frmCadastroUsuarioDescontoRota'
})(modalCadastrarUsuarioDescontoRota));
